import { Component, OnInit, Inject, ViewChildren, QueryList } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { OtService } from '../../../providers/ot.service';
import { BuscarOtComponent } from './buscar-ot/buscar-ot.component';
import { UploaderComponent } from '../../../components/archivo/uploader/uploader.component';

@Component({
  selector: 'app-asignacion-stock',
  templateUrl: './asignacion-stock.component.html',
  styleUrls: ['./asignacion-stock.component.scss']
})
export class AsignacionStockComponent implements OnInit {
  tipoForm: string = '';
  titulo: string = 'Asignación de stock';
  cargando: boolean[] = [];
  model: any;
  model_items: any[] = [];
  form = this._fb.group({
    orden_venta_id: [null, Validators.required],
    items: this._fb.array([]),
  });
  @ViewChildren('uploaderPDTG') uploaderPDTG: QueryList<UploaderComponent>;
  @ViewChildren('uploaderEspecificacionTecnica') uploaderEspecificacionTecnica: QueryList<UploaderComponent>;
  @ViewChildren('uploaderEsquemaDimensiones') uploaderEsquemaDimensiones: QueryList<UploaderComponent>;

  get items() {
    return (this.form.get('items') as FormArray);
  }

  constructor(
    private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private _data,
    private _fb: FormBuilder,
    private _cmSv: ComunicacionService,
    private _otSv: OtService,
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    if (!this._data) {
      throw "La variable Input '_data' es requerida";
    }

    this._prepararForm();
  }

  private _prepararForm() {
    this.model = this._data.model;
    this.form.get('orden_venta_id').setValue(this.model.id);
    this.model_items = this.model.items.slice(0);
    this._renderModelItems();
  }

  // convertimos el json a form para poder hacer ABM
  private _renderModelItems() {
    this.form.controls.items = this._fb.array(this.model_items.map(item => {
      let ordenes_trabajo_array = this._fb.array(item.ordenes_trabajo.map(orden_trabajo => {
        const orden_trabajo_detalles = this._fb.array(orden_trabajo.detalles
          .filter(orden_trabajo_detalle => {
            // si la orden de trabajo detalle no esta asignada a ningún detalle de operación de venta, está en stock
            // si la orden de trabajo detalle está asignada al detalle de esta operación de venta, lo puedo desasignar
            return !orden_trabajo_detalle.orden_venta_detalle_id || orden_trabajo_detalle.orden_venta_detalle_id == item.orden_venta_detalle.id;
          })
          .map(orden_trabajo_detalle => {
            const seleccionado = orden_trabajo_detalle.orden_venta_detalle_id == item.orden_venta_detalle.id;
            const orden_trabajo_detalle_group = this._fb.group({
              orden_trabajo_detalle: orden_trabajo_detalle,
              seleccionado: seleccionado,
            });
            // cuando tildan en el checkbox
            orden_trabajo_detalle_group.get('seleccionado').valueChanges.subscribe((seleccionado) => {
              const orden_trabajo_detalle_seleccionado = orden_trabajo_detalle;
              if (seleccionado) {
                // al asignar, seteamos en todas las OT que este detalle dejó de estar disponible, porque ya fue asignado a una venta
                this.model_items.forEach(it => {
                  const ot = it.ordenes_trabajo.find(ot => ot.id == orden_trabajo_detalle_seleccionado.orden_trabajo_id);
                  if (ot) {
                    // indicar en el detalle seleccionado fue asignado al item de la orden de venta (asignación == orden_venta_detalle_id)
                    ot.detalles.find(ot_dt => ot_dt.id == orden_trabajo_detalle_seleccionado.id).orden_venta_detalle_id = item.orden_venta_detalle.id;
                  }
                });
              } else {
                // al desasignar, seteamos en todas las OT que este detalle está disponible para asignar
                this.model_items.forEach(it => {
                  const ot = it.ordenes_trabajo.find(ot => ot.id == orden_trabajo_detalle_seleccionado.orden_trabajo_id);
                  if (ot) {
                    // si el ítem tiene la OT
                    // indicar en el detalle seleccionado que fue desasignado (asignación == null)
                    ot.detalles.find(ot_dt => ot_dt.id == orden_trabajo_detalle_seleccionado.id).orden_venta_detalle_id = null;
                  }
                });
              }
              setTimeout(() => {
                this._renderModelItems();
              }, 150);
            });
            return orden_trabajo_detalle_group;
          }));
        const orden_trabajo_group = this._fb.group({
          orden_trabajo: orden_trabajo,
          orden_trabajo_detalles: orden_trabajo_detalles
        });
        return orden_trabajo_group;
      }));
      const item_group = this._fb.group({
        item: item,
        ordenes_trabajo: ordenes_trabajo_array,
        pdtg_archivo_id: [item.orden_venta_detalle.pdtg_archivo],
        especificacion_tecnica_archivo_id: [item.orden_venta_detalle.especificacion_tecnica_archivo],
        esquema_dimensiones_archivo_id: [item.orden_venta_detalle.esquema_dimensiones_archivo]
      });
      return item_group;
    }));
  }

  // buscar una orden de trabajo para agregar a las del ítem
  // solo traer ordenes de trabajo que no esten asignadas previamente
  buscarOrdenTrabajo = (item: FormControl) => {
    // buscar orden de trabajo 
    this._dialog.open(BuscarOtComponent, {
      minWidth: '540px',
      data: {}
    }).afterClosed().subscribe((respuesta) => {
      if (respuesta && respuesta.id) {
        // agregar la ot si no fue agregada previamente
        if (!item.value.ordenes_trabajo.find(orden_trabajo => orden_trabajo.id == respuesta.id)) {
          item.value.ordenes_trabajo.unshift(respuesta);
          this._renderModelItems();
        } else {
          this._snackBar.open('La orden de trabajo ya estaba asignada al ítem', 'OK', { duration: 4750 });
        }
      }
    });
  }

  dismiss() {
    this._dialogRef.close();
  }

  guardado_correctamente: boolean = false;
  items_con_todos_los_archivos_subidos: number;
  submit() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      // solo los items seleccioandos enviar
      this.cargando.push(true);
      // guardar operación de venta
      this._otSv.asignarStock(
        this.form.getRawValue(),
      ).subscribe(
        (respuesta) => {
          this.cargando.pop();
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.guardado_correctamente = true;
            this.items_con_todos_los_archivos_subidos = 0;
            this.uploaderPDTG.forEach((uploaderPDTG, index) => {
              uploaderPDTG.uploadAll().subscribe(
                (pdtgUploaded) => {
                  if (pdtgUploaded) {
                    this.uploaderEspecificacionTecnica.toArray()[index].uploadAll().subscribe(
                      (especificacionTecnicaUploaded) => {
                        if (especificacionTecnicaUploaded) {
                          this.uploaderEsquemaDimensiones.toArray()[index].uploadAll().subscribe(
                            (esquemaDimensionesUploaded) => {
                              if (esquemaDimensionesUploaded) {
                                this.items_con_todos_los_archivos_subidos++;
                                // verificar que los archivos de todos los ítems fueron subidos
                                if (this.items_con_todos_los_archivos_subidos == this.uploaderPDTG.length) {
                                  this._dialogRef.close(this.form.getRawValue());
                                }
                              }
                            }
                          )
                        }
                      }
                    );
                  }
                }
              );
            });
          }
        },
        () => {
          this.cargando.pop();
        }
      );
    }
  }

}
